import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export function getAnalyticsCorrelationId(): string {
  const { v1 } = getCommonsNorthboundAPIs()
  const { sessionContext } = v1.store.state.onboarding
  const splunkRumSessionId = v1.monitoring.getSessionId()
  const splunkRumSegment = splunkRumSessionId ? `-[${splunkRumSessionId}]` : ''
  return `${sessionContext.xCorrelationId}${splunkRumSegment}`
}
